<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles">
    <h2 class="modal-title">Ajustar tempos da etapa</h2>
    <span class="modal-subtitle">{{ data.descricaoEtapa }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="dialogRef.close()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="row">
    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Data início</mat-label>
        <input matInput [matDatepicker]="pickerInicio" [ngModel]="dataInicio" (ngModelChange)="dataInicio = $event"
          placeholder="DD/MM/AAAA" (input)="onDateInput($event, 'dataInicio')" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
        <mat-datepicker #pickerInicio></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Hora início</mat-label>
        <input matInput type="time" [(ngModel)]="horaInicio" />
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Data término</mat-label>
        <input matInput [matDatepicker]="pickerFim" [ngModel]="dataFim" (ngModelChange)="dataFim = $event"
          placeholder="DD/MM/AAAA" (input)="onDateInput($event, 'dataFim')" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerFim"></mat-datepicker-toggle>
        <mat-datepicker #pickerFim></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Hora término</mat-label>
        <input matInput type="time" [(ngModel)]="horaFim" />
      </mat-form-field>
    </div>
  </div>

  @if (duracaoCalculada) {
  <p class="texto-duracao">Duração calculada: <strong>{{ duracaoCalculada }}</strong></p>
  }

  @if (mensagemErro) {
  <p class="mensagem-erro">{{ mensagemErro }}</p>
  }

  <p class="texto-ajuda">
    Preencha só a data/hora de início para marcar a etapa como em andamento; preencha as duas para
    concluí-la; limpe ambas para voltar a etapa a pendente.
  </p>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="dialogRef.close()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="salvar()">Salvar</button>
</mat-dialog-actions>
